module.exports = __webpack_public_path__ + "img/kuwait-5.ab91822c.jpg";